import { Field } from "../types/userMenu.types";

export const AccountStatementSearchFields: Field[] = [
  { type: "date" },
  { type: "date" },
  {
    type: "select",
    options: [
      { value: "all", label: "All" },
      { value: "cricket", label: "Cricket" },
      { value: "football", label: "Football" },
      { value: "basketball", label: "Basketball" },
      { value: "tennis", label: "Tennis" },
    ],
  },
];

export const MyBetSearchFields: Field[] = [
  { type: "date" },
  { type: "date" },

  {
    type: "select",
    options: [
      { value: "Matched", label: "Matched" },
      { value: "Un Matched", label: "Un Matched" },
      { value: "status", label: "Be Status" },
    ],
  },
  {
    type: "select",
    options: [
      { value: "all", label: "All" },
      { value: "cricket", label: "Cricket" },
      { value: "football", label: "Football" },
      { value: "basketball", label: "Basketball" },
      { value: "tennis", label: "Tennis" },
    ],
  },
];

export const MyTransactionsSearchFields: Field[] = [
  { type: "date" },
  { type: "date" },

  {
    type: "select",
    options: [
      { value: "all", label: "All" },
      { value: "cricket", label: "Cricket" },
      { value: "football", label: "Football" },
      { value: "basketball", label: "Basketball" },
      { value: "tennis", label: "Tennis" },
    ],
  },
  {
    type: "select",
    options: [
      { value: "all", label: "All" },
      { value: "cricket", label: "Cricket" },
      { value: "football", label: "Football" },
      { value: "basketball", label: "Basketball" },
      { value: "tennis", label: "Tennis" },
    ],
  },
];

export const TurnoverSearchFields: Field[] = [
  { type: "date" },
  { type: "date" },

  {
    type: "select",
    options: [
      { value: "all", label: "All" },
      { value: "cricket", label: "Cricket" },
      { value: "football", label: "Football" },
      { value: "basketball", label: "Basketball" },
      { value: "tennis", label: "Tennis" },
    ],
  },
];

export const BettingProfitLossSearchFields: Field[] = [
  { type: "date" },
  { type: "date" },
];

export const MyWalletSearchFields: Field[] = [
  { type: "date" },
  { type: "date" },
];

export const BonusStatementSearchFields: Field[] = [
  { type: "date" },
  { type: "date" },
];
